import { HttpParams } from '@angular/common/http';
import { GetRolesValue } from './get-roles.value';

export class GetRolesValueDto {
    page: number;
    limit: number;

    constructor(data: GetRolesValue) {
        this.page = data.page;
        this.limit = data.limit;
    }

    toHttpParams(): HttpParams {
        return new HttpParams().set('page', this.page).set('limit', this.limit);
    }
}
